import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './index.scss';
import { isRTL } from '../../../../services/userModel';
import { DELIVERY_TYPE } from '../../../../utils/enums';
import IconButton from '../../IconButton';

export const AddressDraft = ({
  sequenceId,
  depotName,
  address,
  organization,
  city,
  delivery_type = DELIVERY_TYPE.delivery,
}) => {
  const { t } = useTranslation();
  const rtl = isRTL();

  const mergeAddress = useMemo(() => {
    const a = address ? `${address}, ` : '';
    const o = organization ? `${organization}, ` : '';
    const c = city || '';

    return ` ${a}${o}${c}`;
  }, [address, organization, city]);

  return (
    <div className="addressdraft">

      {!!sequenceId && (
        <span className="addressdraft__sequence">
          {rtl ? ` ${sequenceId}#` : `#${sequenceId} `}
        </span>
      )}

      <span className="addressdraft__text addressdraft__text--truncate">
        {depotName}
      </span>

      {delivery_type === DELIVERY_TYPE.delivery ? (
        <>
          {!!mergeAddress.trim() && (
            <IconButton isIcon iconName={rtl ? 'paginationPrevious' : 'paginationNext'} />
          )}

          <span className="addressdraft__text addressdraft__text--truncate addressdraft__text--shrink">
            {mergeAddress}
          </span>
        </>
      ) : (
        <div className="addressdraft__takeaway">
          <IconButton isIcon iconName={'carbonTakeaway'}/>
          <span className="addressdraft__takeaway-text">
            {t('draft.takeaway')}
          </span>
        </div>
      )}
    </div>
  );
};
